import { ChangeDetectorRef, Component } from '@angular/core';
import { ContentService } from '../../services/content.service';
import { environment } from '../../../environments/environment';
import { MenuItem, MessageService } from 'primeng/api';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { SplitButtonModule } from 'primeng/splitbutton';
import { CommonModule } from '@angular/common';

import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { DividerModule } from 'primeng/divider';
import { RippleModule } from 'primeng/ripple';
import { SpeedDialModule } from 'primeng/speeddial';
import { MenuModule } from 'primeng/menu';


import {
  FormControl,
  FormGroup,
  Validators, ReactiveFormsModule } from '@angular/forms';
import { LoginService } from '../../services/login.service';
import { AuthService } from '../../services/auth.service';
import { GeneralEmitterService } from '../../services/general-emitter.service';
import { AdressFormComponent } from '../adress-form/adress-form.component';
import { AddressServiceService } from '../../services/address-service.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [MenubarModule,
    ToastModule,
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    SplitButtonModule,
    DividerModule,
    PasswordModule,
    ToastModule,
    RippleModule,
    SpeedDialModule,
    MenuModule,
    AdressFormComponent
  ],
  providers: [MessageService],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})

export class HeaderComponent {
  information: any;
  // url = environment.apiStrapi;
  items: any;
  itemsPro: MenuItem[] | undefined;
  visible: boolean = false;
  strongPasswordRegx: RegExp = /^(?=[^A-Z]*[A-Z])(?=[^a-z]*[a-z])(?=\D*\d).{8,}$/;
  isTokenExpired: boolean = true;
  modalHeader: string = 'Iniciar Sesión';
  isValidAddress: boolean = false;
  addressInfo: any = null;

  islogin: boolean = true;
  isNewUser: boolean = false;
  isPasswordForgotten: boolean = false;

  chartProducts: number = 0;
  haveLower: boolean = false;
  haveUpper: boolean = false;
  haveNumber: boolean = false;
  haveLength: boolean = false;
  isValidPassword: boolean = false;

  session = new FormGroup({
    mail: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required, Validators.pattern(this.strongPasswordRegx)]),
  });

  newRegister = new FormGroup({
    name: new FormControl('', [Validators.required]),
    mail: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required, Validators.pattern(this.strongPasswordRegx)]),
    passwordConfirm: new FormControl('', [Validators.required]),
  });

  newPassword = new FormGroup({
    mail: new FormControl('sss', [Validators.required, Validators.email]),
  });

  constructor(
    private messageService: MessageService,
    private loginService: LoginService,
    private authService: AuthService,
    private emitterData: GeneralEmitterService,
    private addressService: AddressServiceService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.isTokenExpired = this.authService.isTokenExpired();

    this.itemsPro = [{
        label: 'Cerrar Sesión',
        icon: 'pi pi-cloud',
        command: () => {
          this.logout()
        }
      },
      {
        separator: true
      },
      {
        label: 'Upload',
        routerLink: ['/fileupload']
      }
    ];

    this.items = [
      {
          icon: 'fas fa-user fa-2x',
          items: [
              {
                label: 'Cerrar Sesión',
                icon: 'pi pi-cloud',
                command: () => {
                  this.logout()
                }
              },
          ]
      }
  ]

  this.subsciption();
  this.emitterData.chartData.emit(true);

    
  }

  subsciption() {
    this.emitterData.chartData.subscribe((res) => {
      let info = JSON.parse(localStorage.getItem('productCart') || '[]');
      this.chartProducts = info?.length || 0;
      this.cd.detectChanges();
    })
  }

  get info() {
    return {
      mail: this.session.get('mail'),
      password: this.session.get('password')
    };
  }
  get infoRegister() {
    return {
      name: this.newRegister.get('name'),
      mail: this.newRegister.get('mail'),
      password: this.newRegister.get('password'),
      passwordConfirm: this.newRegister.get('passwordConfirm')
    };
  }
  get infoPassword() {
    return {
      mail: this.newPassword.get('mail'),
    };
  }

  showDialog() {
    this.visible = true;
    this.session.reset()
    this.newRegister.reset();
  }
  closeModal() {
    this.visible = false;
    this.islogin = true;
    this.isNewUser = false;
  }

  showSection(section: any) {
    switch(section) {
      case 'login':
        this.modalHeader = 'Iniciar Sesión';
        this.islogin = true;
        this.isNewUser = false;
        this.isPasswordForgotten = false;
        break;
      case 'close':
        this.modalHeader = 'Iniciar Sesión';
        this.islogin = true;
        this.isNewUser = false;
        this.isPasswordForgotten = false;
        this.visible = false;
        break;
      case 'user':
        this.modalHeader = 'Registro';
        this.islogin = false;
        this.isNewUser = true;
        this.isPasswordForgotten = false;
        break;
      case 'password':
        this.modalHeader = 'Cambio de contraseña';
        this.islogin = false;
        this.isNewUser = false;
        this.isPasswordForgotten = true;
        break;
      default:
        break;
    }
  }

  showMessage(severity: string = 'success', summary: string = '', detail: string = '') {
    this.messageService.add({ severity, summary, detail });
  }

  async login() {
    let payload = {
      password: this.session.controls['password'].value,
      email: this.session.controls['mail'].value,
    }

    this.loginService.initLogin(payload).subscribe({
      next: (res: any) => {
        if (res.access_token) {
          this.isTokenExpired = false;
          this.visible = false;
          this.showMessage('success', 'Bienvenido', 'Inicio de sesión correcto.');
        }
      }, error: (error:any) => {
        console.log('errr', error)
        this.showMessage('error', 'Error de sesión', 'Los datos ingresados son incorrectos. Favor de verificarlos');
      }
    });
  }

  logout() {
    this.loginService.logout().subscribe((res: any) => {
      this.isTokenExpired = true;
    })
  }

  setPassword() {
    this.validatePassword();
  }

  validatePassword() {
    const pass = this.newRegister.controls['password'].value ;
    const passConfirm = this.newRegister.controls['passwordConfirm'].value ;
    this.isValidPassword = (pass == passConfirm);
  }

  registerUser() {
    let payload = {
        name: this.newRegister.controls['name'].value,
        password: this.newRegister.controls['password'].value,
        phone: this.newRegister.controls['phone'].value,
        email: this.newRegister.controls['mail'].value,
        isActive: false,
        address: this.addressInfo
    };

   this.loginService.newUser(payload).subscribe({
     next: (res: any) => {
       if ( res.status == 200 ) {
         this.showSection('close');
         this.showMessage('success', 'Registro exitoso','Para validar su usuario, se ha enviado un mensaje al correo registrado.' );
        //  let addressPayload = this.addressInfo;
        //  addressPayload['usr'] = res.userId;

        //  this.addressService.addAddress(addressPayload).subscribe({
        //     next: (res: any) => {
        //       if ( res.status == 200 ) {
        //         this.showMessage('success', 'Registro exitoso','Para validar su usuario, se ha enviado un mensaje al correo registrado.' );
        //       }
        //     }, error: (error: any) => {
        //       this.showMessage('error', 'Ocurrio un error', error.error );
        //     }
        //   });
        }
        if ( res.status == 400 ) {
          this.showMessage('error', 'Ocurrió un error', res.message ?? res.error);
        }
      }, error: (error: any) => {
        this.showMessage('error', 'Ocurrio un error', error.error );
      }
  })
  }

  changePassword() {
    let mail = this.newPassword.controls['mail'].value;
    this.loginService.requestPassword(mail).subscribe({
      next: (res: any) => {
        if ( res.status == 200 ) {
          this.showSection('close');
          this.showMessage('success', 'Solicitud en Proceso','Para seguir con su solicitud, se ha enviado un mensaje al correo registrado.' );
        }
        if ( res.status == 400 ) {
          this.showMessage('error', 'Ocurrió un error', res.message ?? res.error);
        }

      }, error: (error: any) => {
        this.showMessage('error', 'Ocurrió un error', error.message ?? error.error);
      }
    });
  }

  sss() {
    console.log(this.session)
  }

  setPass(ev: any) {
    this.validatePassword();
    this.testStrength();
  }

  testStrength() {
    let pass = this.newRegister.controls['password'].value || '';
    let level = 0;

    if (/[a-z]{1,}/.test(pass)) {
      this.haveLower = true;
      level++;
    }
    if (/[A-Z]{1,}/.test(pass)) {
      this.haveUpper = true;
      level++;
    }
    if (/[0-9]{1,}/.test(pass)) {
      this.haveNumber = true;
      level++;
    }
    this.haveLength = pass.length >= 8;

    return level;
  }

  openWhats(){

  }

  getAddress(event:any) {
    this.addressInfo = event;
  }

  getIsValidInfo(event:any) {
    this.isValidAddress = event
  }
}
